import {Injectable, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    public HasTheme$ = new BehaviorSubject<boolean>(false);
    public Theme$ = new BehaviorSubject<string>('');
    public Name$ = new BehaviorSubject<string>('');
    public Color$ = new BehaviorSubject<string>('#f39325');
    public Logo$ = new BehaviorSubject<string|null>(null);
    protected params$: Observable<any> = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
            let route = this.router.routerState.root
            if (route === null) return null; //or throw ?
            while (route.firstChild) route = route.firstChild;
            return route.snapshot.params;
        })
    );

    constructor(
        protected router: Router,
        protected http: HttpClient
    ) {
        this.params$.subscribe(p => {
            if (p.theme !== undefined) {
                this.Theme$.next(p.theme);
                http.get<{color:string,logo:string,name:string}>('/assets/themes/'+p.theme+'.json').toPromise().then(res => {
                    this.HasTheme$.next(true);
                    this.Color$.next(res.color);
                    this.Logo$.next(res.logo);
                    this.Name$.next(res.name);
                }, err => console.error(err));
            }
        });
        this.Color$.subscribe(c => {
            document.documentElement.style.setProperty('--primary-color', c);
        })
    }
}
